import React from 'react';

import { FormInstance } from 'antd';
import {
  Input,
  Select,
} from 'UI';
import { Variety } from 'constants/interface';

import {
  FormContainer,
  BaseFormItem,
  SeedsInline,
  NotesInline,
} from './style';

export interface AddVarietyFormData {
  name: string
  seedConsumption: number
  notes?: string
}

interface AddFormProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  isLoading?: boolean
  // culture?: Culture
  varietyBasicData?: Variety,
}

const AddForm = ({
  formHandler,
  onSubmit,
  isLoading,
  // culture,
  varietyBasicData,
}: AddFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    onFinish={onSubmit as (val: unknown) => void}
  >
    <BaseFormItem
      label="Cultura"
      name="culture"
      initialValue={varietyBasicData?.culture?.name}
      rules={[
        {
          required: true,
          message: 'Nenhuma cultura selecionada',
        },
      ]}
    >
      <Input disabled />
    </BaseFormItem>
    <BaseFormItem
      label="Variedade"
      name="name"
      initialValue={varietyBasicData?.name}
      rules={[
        {
          required: true,
          message: 'Insira uma variedade',
        },
      ]}
    >
      <Input disabled />
    </BaseFormItem>
    <SeedsInline
      label="Sementes por célula"
      name="seedConsumption"
      initialValue={varietyBasicData?.seedConsumption || 1}
    >
      <Select
        disabled={isLoading}
        // defaultValue={1}
        className="seed-consumption-input"
      >
        {[1, 2, 3, 4, 5].map((val) => (
          <Select.Option value={val} key={val}>
            {val}
          </Select.Option>
        ))}
      </Select>
    </SeedsInline>
    <NotesInline
      label="Observações"
      name="notes"
      initialValue={varietyBasicData?.notes}
    >
      <Input.TextArea disabled={isLoading} rows={5} />
    </NotesInline>
  </FormContainer>
);

AddForm.defaultProps = {
  isLoading: false,
  varietyBasicData: undefined,
};

export default AddForm;
